/**
 * Modèle PlayerStepAttribute - Identique à Flutter
 */

export interface PlayerStepAttribute {
  name: string;
  description: string;
  qualification: string; // OBJECT, FEATURE, BUTTERFLY_EFFECT
  value?: string;
  image?: string;
  order?: number;
}

export const PlayerStepAttributeFromJson = (json: any): PlayerStepAttribute => {
  if (!json || typeof json.name !== 'string') {
    throw new Error('Invalid PlayerStepAttribute JSON: missing name');
  }

  return {
    name: json.name,
    description: json.description || '',
    qualification: json.qualification || 'FEATURE',
    value: json.value,
    image: json.image,
    order: json.order != null ? Number(json.order) : undefined,
  };
};

export const PlayerStepAttributeGetLabel = (attr: PlayerStepAttribute): string => {
  let label = attr.name;
  if (attr.value != null && attr.value.trim() !== '') {
    label += ` (${attr.value})`;
  }
  return label;
};
